// src/features/shared/components/layout/AuthLayout.tsx
import React from 'react';
import { Outlet } from 'react-router-dom';
import { ThemeToggle } from '@/features/shared/theme/ThemeToggle';
import { LanguageSwitcher } from '@/features/shared/components/LanguageSwitcher';

/**
 * Wrapper for all public (unauthenticated) pages. Carries the global KaziPeople
 * theme surface plus a floating control cluster — light/dark toggle + language
 * switcher — so every public page (login, register, onboarding, forgot/reset…)
 * lets the visitor pick their theme and language.
 */
export const AuthLayout: React.FC = () => {
  return (
    <div className="min-h-screen bg-muted relative">
      <div className="absolute top-4 right-4 z-50 flex items-center gap-2">
        <LanguageSwitcher />
        <ThemeToggle />
      </div>
      <Outlet />
    </div>
  );
};

export default AuthLayout;
